module.exports = __webpack_public_path__ + "static/media/DSMInactive.33fd0c98.png";